import {
  mdiChevronLeft,
  mdiPlusCircleOutline,
  mdiRefresh,
  mdiTrashCanOutline
} from '@mdi/js'
import { mapActions, mapState } from 'vuex'

export default {
  data() {
    return {
      icons: {
        delete: mdiTrashCanOutline,
        plusCircle: mdiPlusCircleOutline,
        arrowLeft: mdiChevronLeft,
        refresh: mdiRefresh
      }
    }
  },

  computed: {
    ...mapState({
      tripTypes: state => state.options.trip_types,
      accommodationTypes: state => state.options.accommodation_types,
      landmarks: state => state.options.landmarks,
      stores: state => state.options.stores,
      restaurants: state => state.options.restaurants,
      fetchingLandmarks: state => state.options.fetching_landmarks,
      fetchingStores: state => state.options.fetching_stores,
      fetchingRestaurants: state => state.options.fetching_restaurants,
      fetchingTripTypes: state => state.options.fetching_trip_types,
      fetchingAccommodationTypes: state =>
        state.options.fetching_accommodation_types
    })
  },

  methods: {
    ...mapActions({
      getTripTypes: 'options/getTripTypes',
      getAccommodationTypes: 'options/getAccommodationTypes',
      getLandmarks: 'options/getLandmarks',
      getStores: 'options/getStores',
      getRestaurants: 'options/getRestaurants'
    }),

    getDropdownOptions() {
      this.getTripTypes()
      this.getAccommodationTypes()
      this.getLandmarks()
      this.getStores()
      this.getRestaurants()
    }
  }
}
